export default "__VITE_ASSET__BoVZMApw__"